import React from "react";
import CtaOne from "@components/CTA/CtaOne";
import BlogCard from "@components/Blog/BlogCard";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const FeaturedBlogs = ({
  header = true,
  heading2 = "Take a Look at Our Featured Articles",
  paragraph = "These articles will guide you on how to simplify office work, boost your efficiency, and concentrate on expanding your business.",
  blogCards,
}) => {
  return (
    <div className="w-full flex flex-col">
      {header && (
        <>
          <div className="text-center max-w-screen-xl md:px-20 px-6 mx-auto">
            <CtaOne
              heading2={heading2}
              paragraph={paragraph}
              paragraphStyling={`max-w-[600px] mx-auto`}
            />
          </div>
          {/* <div className="w-full bg-gray-200 relative">
            <Image
              src={`${BASE_ASSETS_URL}/v2/arrow.svg`}
              width={10}
              height={10}
              className={`moveUpObject w-[50px] sm:w-[80px] absolute -top-4 sm:-top-20 lg:-top-48 left-[5%] lg:left-[10%]`}
              alt="hero"
            />
            <Image
              src={`${BASE_ASSETS_URL}/v2/wheel.svg`}
              width={10}
              height={10}
              className={`rotateObject w-[50px] sm:w-[80px] absolute -top-8 sm:-top-20 lg:-top-32 right-[5%] lg:right-[10%]`}
              alt="hero"
            />
          </div> */}
        </>
      )}
      <div className="mt-16 sm:mt-6 flex flex-col md:flex-row gap-6 sm:max-w-[80%] md:max-w-full mx-auto">
        {blogCards.map((card, index) => (
          <BlogCard key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default FeaturedBlogs;
